module.exports = "img/RightArrow.3cdc6c.png";